"use strict";

var _interopRequireDefault = require("/code/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.regexp.search");
var _utils = require("@/utils");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _role = require("@/api/role");
var _org = require("@/api/org");
var _user = require("@/api/user");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var defaultRole = {
  name: "",
  description: "",
  perms: [],
  datas: "本级及以下",
  depts: [],
  type: null
};
var _default = exports.default = {
  data: function data() {
    return {
      search: "",
      role: Object.assign({}, defaultRole),
      routes: [],
      tableData: [],
      rolesList: [],
      dialogVisible: false,
      dialogType: "new",
      checkStrictly: true,
      listLoading: true,
      orgData: [],
      dataOptions: [{
        value: "全部",
        label: "全部"
      }, {
        value: "自定义",
        label: "自定义"
      }, {
        value: "同级及以下",
        label: "同级及以下"
      }, {
        value: "本级及以下",
        label: "本级及以下"
      }, {
        value: "本级",
        label: "本级"
      }, {
        value: "仅本人",
        label: "仅本人"
      }],
      typeOptions: [{
        value: 1,
        label: '销售角色'
      }, {
        value: 2,
        label: '非销售角色'
      }, {
        value: 3,
        label: '外部公司销售角色'
      }, {
        value: 4,
        label: '外部公司非销售角色'
      }],
      rule1: {
        name: [{
          required: true,
          message: '请输入名称',
          trigger: 'blur'
        }, {
          max: 32,
          message: '输入长度不能超过32位'
        }]
      }
    };
  },
  computed: {},
  created: function created() {
    // Mock: get all routes and roles list from server
    this.getRoutes();
    this.getOrgAll();
    this.getRoleAll();
  },
  methods: {
    checkPermission: _permission.default,
    handleFilter: function handleFilter() {
      var _this = this;
      var newData = this.rolesList.filter(function (data) {
        return !_this.search || data.name.toLowerCase().includes(_this.search.toLowerCase());
      });
      this.tableData = (0, _utils.genTree)(newData);
    },
    getRoutes: function () {
      var _getRoutes2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _role.getRoutes)();
            case 2:
              res = _context.sent;
              // this.serviceRoutes = res.data
              this.routes = (0, _utils.genTree)(res.data);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getRoutes() {
        return _getRoutes2.apply(this, arguments);
      }
      return getRoutes;
    }(),
    getOrgAll: function () {
      var _getOrgAll2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return (0, _org.getOrgAll)();
            case 2:
              res = _context2.sent;
              this.orgData = (0, _utils.genTree)(res.data);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getOrgAll() {
        return _getOrgAll2.apply(this, arguments);
      }
      return getOrgAll;
    }(),
    getRoleAll: function () {
      var _getRoleAll2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.listLoading = true;
              _context3.next = 3;
              return (0, _role.getRoleAll)();
            case 3:
              res = _context3.sent;
              this.tableData = res.data;
              this.rolesList = res.data;
              this.listLoading = false;
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getRoleAll() {
        return _getRoleAll2.apply(this, arguments);
      }
      return getRoleAll;
    }(),
    handleAdd: function handleAdd() {
      this.role = Object.assign({}, defaultRole);
      if (this.$refs.tree) {
        this.$refs.tree.setCheckedNodes([]);
      }
      this.dialogType = "new";
      this.dialogVisible = true;
    },
    handleEdit: function handleEdit(scope) {
      var _this2 = this;
      this.dialogType = "edit";
      this.dialogVisible = true;
      this.role = (0, _utils.deepClone)(scope.row);
      this.$nextTick(function () {
        _this2.$refs.tree.setCheckedKeys(_this2.role.perms);
        _this2.$refs.depts_tree.setCheckedKeys(_this2.role.depts);
      });
    },
    handleDelete: function handleDelete(_ref) {
      var _this3 = this;
      var $index = _ref.$index,
        row = _ref.row;
      this.$confirm("确认删除?", "警告", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4() {
        var result, count;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              result = true;
              count = 0;
              _context4.next = 4;
              return (0, _user.getUserList)().then(function (response) {
                if (response.data) {
                  count = response.data.count;
                }
              });
            case 4:
              _context4.next = 6;
              return (0, _user.getUserList)({
                page: 1,
                page_size: count
              }).then(function (res) {
                for (var i = 0; i < res.data.count; i++) {
                  console.log(res.data.results[i].roles[0]);
                  if (res.data.results[i].roles[0] === row.id) {
                    result = false;
                  }
                }
              });
            case 6:
              console.log(result);
              if (!result) {
                _context4.next = 14;
                break;
              }
              _context4.next = 10;
              return (0, _role.deleteRole)(row.id);
            case 10:
              _this3.tableData.splice($index, 1);
              _this3.$message.success("成功");
              _context4.next = 15;
              break;
            case 14:
              _this3.$message({
                type: 'error',
                message: '角色正在使用!'
              });
            case 15:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))).catch(function (err) {
        console.error(err);
      });
    },
    confirmRole: function () {
      var _confirmRole = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee6(form) {
        var _this4 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              this.$refs[form].validate(/*#__PURE__*/function () {
                var _ref3 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee5(valid) {
                  var isEdit, index, _this4$role, description, name;
                  return (0, _regeneratorRuntime2.default)().wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        if (!valid) {
                          _context5.next = 24;
                          break;
                        }
                        isEdit = _this4.dialogType === "edit";
                        _this4.role.perms = _this4.$refs.tree.getCheckedKeys();
                        if (_this4.role.datas === "自定义") {
                          _this4.role.depts = _this4.$refs.depts_tree.getCheckedKeys();
                        } else {
                          _this4.role.depts = [];
                        }
                        if (!isEdit) {
                          _context5.next = 17;
                          break;
                        }
                        _context5.next = 7;
                        return (0, _role.updateRole)(_this4.role.id, _this4.role);
                      case 7:
                        index = 0;
                      case 8:
                        if (!(index < _this4.tableData.length)) {
                          _context5.next = 15;
                          break;
                        }
                        if (!(_this4.tableData[index].id === _this4.role.id)) {
                          _context5.next = 12;
                          break;
                        }
                        _this4.tableData.splice(index, 1, Object.assign({}, _this4.role));
                        return _context5.abrupt("break", 15);
                      case 12:
                        index++;
                        _context5.next = 8;
                        break;
                      case 15:
                        _context5.next = 21;
                        break;
                      case 17:
                        _this4.role.perms = _this4.$refs.tree.getCheckedKeys();
                        // const { data } = await createRole(this.role)
                        _context5.next = 20;
                        return (0, _role.createRole)(_this4.role);
                      case 20:
                        _this4.getRoleAll();
                      case 21:
                        _this4$role = _this4.role, description = _this4$role.description, name = _this4$role.name;
                        _this4.dialogVisible = false;
                        _this4.$message.success("成功");
                      case 24:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5);
                }));
                return function (_x2) {
                  return _ref3.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function confirmRole(_x) {
        return _confirmRole.apply(this, arguments);
      }
      return confirmRole;
    }(),
    clickDeal: function clickDeal(currentObj, treeStatus) {
      // 用于：父子节点严格互不关联时，父节点勾选变化时通知子节点同步变化，实现单向关联。
      var selected = treeStatus.checkedKeys.indexOf(currentObj.id); // -1未选中
      console.log(currentObj);
      // 选中
      if (selected !== -1) {
        if (currentObj.children && currentObj.children.length !== 0) {
          // 子节点只要被选中父节点就被选中
          this.selectedParent(currentObj);
          // 统一处理子节点为相同的勾选状态
          this.uniteChildSame(currentObj, true);
        } else {
          this.selectedParent(currentObj);
        }
      } else {
        // 未选中 处理子节点全部未选中
        if (currentObj.children && currentObj.children.length !== 0) {
          this.uniteChildSame(currentObj, false);
        }
      }
    },
    // 统一处理子节点为相同的勾选状态
    uniteChildSame: function uniteChildSame(treeList, isSelected) {
      console.log(treeList);
      this.$refs.tree.setChecked(treeList.id, isSelected);
      if (treeList.children && treeList.children.length !== 0) {
        for (var i = 0; i < treeList.children.length; i++) {
          this.uniteChildSame(treeList.children[i], isSelected);
        }
      }
    },
    // 统一处理父节点为选中
    selectedParent: function selectedParent(currentObj) {
      var currentNode = this.$refs.tree.getNode(currentObj);
      console.log(currentNode);
      if (currentNode.parent.key !== undefined) {
        this.$refs.tree.setChecked(currentNode.parent, true);
        this.selectedParent(currentNode.parent);
      }
    }
  }
};